export default __webpack_public_path__ + "static/brassHero-97523523a64ce3d3d8a35a52d6b33390.jpg";